export enum ImagesSectionContentLayoutType {
  ImageContentLayout = 'imageContentLayout',
  ContentImageLayout = 'contentImageLayout',
}
